<template>
  <div class="login-page">
    <div class="login-contents">
      <div class="login-contents__sub">キャンペーン価格での購入を行うためには、アプリ上でのメールアドレス登録が必要です。登録後に再度このページにアクセスしてください。</div>
      <div class="login-contents__img">
        <img v-bind:src="require('../../../static/img/account-create.png')" alt="" height="350"/>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    title: 'アカウント',
    headerTitle: 'アカウント',
    headerType: 'historyBack',
    resetScrollView: true,
    data() {
      return {
        email: "",
        pass: "",
        allow_campaign: true,
        hasLoaded : false
      }
    },
    created() {
      this.getStatus();
    },
    mounted() {
    },
    methods: {
      registerProfile() {

      },
      changeAllowCampaign() {
        this.allow_campaign = !this.allow_campaign;
      },
      getStatus() {
        this.$store.dispatch("changeLoadingCondition", true);
        let token = "";
        if (this.$route.query.token) {
          token = this.$route.query.token;
        }
        this.$store.dispatch('getUserSettings', {token:token})
          .then(data => {
            this.responseError = data === 'error';
            this.$store.dispatch("changeLoadingCondition", false);
            //ログイン成功の場合はログイン処理を行う
            if (data.has_logined) {
              if (data.login_info) {
                this.$store.dispatch("setLogin", data.login_info);
              }
            }
            if (data.user && data.user.email) {
              //メールアドレス登録済み、購入画面に移る
              this.$router.replace({
                name: 'UnlimitedPlus',
                query: { skipPremium: this.$route.query.skipPremium }
              });
            } else {
              this.hasLoaded = true;
            }
          })
          .catch(() => {
            alert('通信に失敗しました。');
            this.$store.dispatch("changeLoadingCondition", false);
          });
      }
    }
  }
</script>

<style scoped lang="scss">
  .login-page {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    bottom: 0;
    background: #fff;
    position: fixed;
    .login-contents {
      &__img {
        margin-top: 20px;
      }
      &__sub {
        margin: 20px 10px;
        font-weight: normal;
        font-size: 1.5rem;
        line-height: 2.0;
        text-align: center;

      }
      &__ttl {
        font-weight: normal;
        font-size: 3.8rem;
        text-align: center;
      }
      &__abceed {
        color: #ff223C;
        font-size: 4.2rem;
        letter-spacing: .02em;
        font-family: Montserrat,sans-serif;
        font-weight: 500;
        text-align: center;
        margin-bottom: 30px;
      }
    }
    .password-forget {
      font-size: 1.2rem;
      text-align: center;
      margin-top: -2px;
      margin-bottom: 40px;
      a {
        color: #ee1313;
        transition: 0.3s;
        &:hover {
          text-decoration: none;
          opacity: 0.6;
          transition: 0.3s;
        }
      }
    }
    .login-maintain {
      padding: 20px 0 30px;
      font-size: 1.2rem;
      color: #b3b2b2;
      text-align: center;
    }
    .login-input-text {
      input {
        padding: 5px;
        height: 42px;
        padding: 0 10px;
        font-size: 1.6rem;
        border-radius: 3px;
      }
    }
    .login-submit-text {
      font-size: 2.8rem;
      text-align: center;
      a {
        color: #ee1313;
        transition: 0.3s;
        &:hover {
          text-decoration: none;
          opacity: 0.6;
          transition: 0.3s;
        }
      }
    }
    .login {
      width: 360px;
      padding: 5px 24px 34px;
      margin: 0 auto;
      .input-label {
        font-size: 1.6rem;
        text-align: left;
      }
      .form-text {
        margin-bottom: 10px;
        width: calc(100% - 20px);
        height: 32px;
        padding: 5px 10px;
        box-sizing: content-box;
        line-height: 32px;
      }
    }
  }

  .ie-alert {
    padding: 20px 0 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/campainPage/AccountCreate.vue